<template>
  <v-dialog v-model="open" persistent max-width="520">
    <v-card>
      <v-card-title>
        <v-icon :color="iconColor" class="me-2">{{ icon }}</v-icon>
        <span class="text-h6">{{ title }}</span>
      </v-card-title>

      <v-card-text>
        <p class="mb-4">{{ text }}</p>

        <!-- The family finds out tomorrow morning otherwise: the bus goes past
             and nobody knows why. Off by default, because a change corrected a
             minute later is not worth telling anyone about. -->
        <v-switch
          v-model="notify"
          :label="notifyLabel || $t('notify_the_family')"
          :hint="$t('notify_the_family_hint')"
          persistent-hint
          dense
          inset
        ></v-switch>

        <v-textarea
          v-if="notify"
          v-model="reason"
          :label="$t('reason_optional')"
          :hint="$t('reason_hint')"
          persistent-hint
          rows="2"
          class="mt-4"
          counter="500"
          :rules="reasonRules"
        ></v-textarea>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
        <v-btn :color="confirmColor" text @click="confirm">
          {{ confirmText || $t('yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*
 * Confirm an action and, in the same breath, offer to tell the family why.
 *
 * Suspending a child, moving them to another bus and taking away their stop are
 * all decisions the family has to act on the next morning, and none of them told
 * anyone: the school changed the record and the parent found out when the bus
 * did not come. Rather than bolting a notification onto each screen separately,
 * every one of those actions asks the same question in the same place.
 *
 *   <confirm-notify-dialog
 *     v-model="dialog"
 *     :title="..." :text="..."
 *     @confirm="({ notify, reason }) => ..." />
 */
export default {
  name: "ConfirmNotifyDialog",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    confirmText: { type: String, default: "" },
    confirmColor: { type: String, default: "primary" },
    icon: { type: String, default: "mdi-help-circle-outline" },
    iconColor: { type: String, default: "primary" },
    notifyLabel: { type: String, default: "" },
  },
  data() {
    return {
      notify: false,
      reason: "",
      reasonRules: [(v) => !v || v.length <= 500 || this.$t("reason_too_long")],
    };
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.notify = false;
        this.reason = "";
      }
    },
  },
  methods: {
    cancel() {
      this.open = false;
      this.$emit("cancel");
    },
    confirm() {
      if (this.reason && this.reason.length > 500) return;

      this.open = false;
      this.$emit("confirm", {
        notify: this.notify,
        reason: this.reason ? this.reason.trim() : "",
      });
    },
  },
};
</script>
